import { useState, useEffect } from 'react';
import { supabase } from '../../supabase';

function SocialCalendario({ cliente, setPaginaAtiva }) {
  const [posts, setPosts] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [mesAtual, setMesAtual] = useState(new Date());
  const [modalAberto, setModalAberto] = useState(false);
  const [diaSelecionado, setDiaSelecionado] = useState(null);
  const [postSelecionado, setPostSelecionado] = useState(null);
  const [form, setForm] = useState({ nome: '', status: 'producao' });
  const [salvando, setSalvando] = useState(false);

  useEffect(() => { if (cliente) carregarPosts(); }, [cliente, mesAtual]);

  const getMesLabel = () => {
    const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
    return `${meses[mesAtual.getMonth()]} ${mesAtual.getFullYear()}`;
  };

  const mudarMes = (dir) => {
    const novo = new Date(mesAtual);
    novo.setMonth(mesAtual.getMonth() + dir);
    setMesAtual(novo);
  };

  const carregarPosts = async () => {
    const inicioMes = `${mesAtual.getFullYear()}-${String(mesAtual.getMonth() + 1).padStart(2, '0')}-01`;
    const fimMes = new Date(mesAtual.getFullYear(), mesAtual.getMonth() + 1, 0).toISOString().split('T')[0];
    const { data } = await supabase
      .from('social_posts')
      .select('*')
      .eq('cliente_id', cliente.id)
      .gte('data_post', inicioMes)
      .lte('data_post', fimMes)
      .order('data_post');
    setPosts(data || []);
    setCarregando(false);
  };

  const getDiasMes = () => {
    const ano = mesAtual.getFullYear();
    const mes = mesAtual.getMonth();
    const primeiroDia = new Date(ano, mes, 1).getDay();
    const totalDias = new Date(ano, mes + 1, 0).getDate();
    const dias = [];
    for (let i = 0; i < primeiroDia; i++) dias.push(null);
    for (let i = 1; i <= totalDias; i++) dias.push(i);
    return dias;
  };

  const getDataKey = (dia) => {
    return `${mesAtual.getFullYear()}-${String(mesAtual.getMonth() + 1).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
  };

  const getPostsDia = (dia) => {
    if (!dia) return [];
    return posts.filter(p => p.data_post === getDataKey(dia));
  };

  const isHoje = (dia) => {
    const hoje = new Date();
    return dia === hoje.getDate() && mesAtual.getMonth() === hoje.getMonth() && mesAtual.getFullYear() === hoje.getFullYear();
  };

  const abrirModal = (dia, post = null) => {
    setDiaSelecionado(dia);
    setPostSelecionado(post);
    setForm(post ? { nome: post.nome, status: post.status } : { nome: '', status: 'producao' });
    setModalAberto(true);
  };

  const salvar = async () => {
    if (!form.nome.trim()) return;
    setSalvando(true);
    if (postSelecionado) {
      await supabase.from('social_posts').update({
        nome: form.nome,
        status: form.status,
        atualizado_em: new Date().toISOString(),
      }).eq('id', postSelecionado.id);
    } else {
      await supabase.from('social_posts').insert({
        cliente_id: cliente.id,
        data_post: getDataKey(diaSelecionado),
        nome: form.nome,
        status: form.status,
      });
    }
    setSalvando(false);
    setModalAberto(false);
    carregarPosts();
  };

  const deletar = async () => {
    if (!postSelecionado) return;
    await supabase.from('social_posts').delete().eq('id', postSelecionado.id);
    setModalAberto(false);
    carregarPosts();
  };

  const getStatusStyle = (status) => {
    if (status === 'postado') return { dot: '#22c55e', bg: '#0d2a0d', color: '#22c55e' };
    if (status === 'cancelado') return { dot: '#555', bg: '#1a1a1a', color: '#555' };
    return { dot: '#f59e0b', bg: '#2a1f00', color: '#f59e0b' };
  };

  const dias = getDiasMes();
  const semanas = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  if (!cliente) return null;
  if (carregando) return <div className="flex items-center justify-center h-64"><p style={{ color: '#555' }}>Carregando...</p></div>;

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <button onClick={() => setPaginaAtiva('social_cliente')} className="text-sm" style={{ color: '#555' }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
            onMouseLeave={(e) => e.currentTarget.style.color = '#555'}>
            ← {cliente.nome}
          </button>
          <span style={{ color: '#333' }}>/</span>
          <h1 className="text-xl font-bold text-white">Calendário</h1>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={() => mudarMes(-1)} className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a', color: '#aaa' }}>‹</button>
          <span className="text-sm font-medium text-white px-2">{getMesLabel()}</span>
          <button onClick={() => mudarMes(1)} className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a', color: '#aaa' }}>›</button>
        </div>
      </div>

      {/* Legenda */}
      <div className="flex gap-4 mb-4">
        {[
          { status: 'producao', label: 'Produção', color: '#f59e0b' },
          { status: 'postado', label: 'Postado', color: '#22c55e' },
          { status: 'cancelado', label: 'Cancelado', color: '#555' },
        ].map(s => (
          <div key={s.status} className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-full" style={{ backgroundColor: s.color }} />
            <span className="text-xs" style={{ color: '#555' }}>{s.label}</span>
          </div>
        ))}
        <span className="text-xs ml-auto" style={{ color: '#333' }}>clique em qualquer dia para adicionar post</span>
      </div>

      {/* Calendário */}
      <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #1a1a1a' }}>
        {/* Headers dias */}
        <div className="grid grid-cols-7" style={{ backgroundColor: '#111', borderBottom: '1px solid #1a1a1a' }}>
          {semanas.map(s => (
            <div key={s} className="text-center py-2 text-xs font-medium" style={{ color: '#555' }}>{s}</div>
          ))}
        </div>

        {/* Dias */}
        <div className="grid grid-cols-7" style={{ backgroundColor: '#0d0d0d' }}>
          {dias.map((dia, i) => {
            const postsDia = getPostsDia(dia);
            const hoje = dia && isHoje(dia);
            return (
              <div
                key={i}
                onClick={() => dia && abrirModal(dia)}
                className="p-2 cursor-pointer transition-all"
                style={{
                  minHeight: '90px',
                  borderRight: (i + 1) % 7 !== 0 ? '1px solid #1a1a1a' : 'none',
                  borderBottom: i < dias.length - 7 ? '1px solid #1a1a1a' : 'none',
                  backgroundColor: !dia ? '#0a0a0a' : hoje ? '#0d1a0d' : 'transparent',
                  cursor: dia ? 'pointer' : 'default',
                  opacity: !dia ? 0.3 : 1,
                }}
                onMouseEnter={(e) => { if (dia) e.currentTarget.style.backgroundColor = '#151515'; }}
                onMouseLeave={(e) => { if (dia) e.currentTarget.style.backgroundColor = hoje ? '#0d1a0d' : 'transparent'; }}
              >
                {dia && (
                  <>
                    <div className="flex items-center gap-1 mb-1">
                      <span className="text-xs font-medium" style={{ color: hoje ? '#22c55e' : '#666' }}>{dia}</span>
                      {hoje && <span className="text-xs px-1 rounded" style={{ backgroundColor: '#0d2a0d', color: '#22c55e', fontSize: '9px' }}>hoje</span>}
                    </div>
                    {postsDia.map(post => {
                      const st = getStatusStyle(post.status);
                      return (
                        <div
                          key={post.id}
                          onClick={(e) => { e.stopPropagation(); abrirModal(dia, post); }}
                          className="relative text-xs px-1.5 py-1 rounded mb-1 truncate"
                          style={{ backgroundColor: st.bg, color: st.color, paddingRight: '14px' }}
                        >
                          {post.nome}
                          <div className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full" style={{ backgroundColor: st.dot }} />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Modal */}
      {modalAberto && (
        <div className="fixed inset-0 flex items-center justify-center z-50"
          style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
          onClick={() => setModalAberto(false)}>
          <div className="rounded-2xl p-6 w-full max-w-sm"
            style={{ backgroundColor: '#111', border: '1px solid #333' }}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-base font-semibold text-white">
                {postSelecionado ? 'Editar post' : `Novo post — dia ${diaSelecionado}`}
              </h2>
              <button onClick={() => setModalAberto(false)} style={{ color: '#555' }} className="text-lg hover:text-white">✕</button>
            </div>

            <div className="flex flex-col gap-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Nome do post</label>
                <input type="text" value={form.nome}
                  onChange={(e) => setForm({ ...form, nome: e.target.value })}
                  onKeyDown={(e) => e.key === 'Enter' && salvar()}
                  placeholder="Ex: Reels bastidores, Carrossel produto..."
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}
                  autoFocus />
              </div>
              <div>
                <label className="text-xs mb-2 block" style={{ color: '#555' }}>Status</label>
                <div className="flex gap-2">
                  {[
                    { val: 'producao', label: 'Produção', color: '#f59e0b', bg: '#2a1f00' },
                    { val: 'postado', label: 'Postado', color: '#22c55e', bg: '#0d2a0d' },
                    { val: 'cancelado', label: 'Cancelado', color: '#555', bg: '#1a1a1a' },
                  ].map(s => (
                    <button key={s.val} onClick={() => setForm({ ...form, status: s.val })}
                      className="flex-1 py-2 rounded-lg text-xs font-medium transition-all"
                      style={{
                        backgroundColor: form.status === s.val ? s.bg : '#1a1a1a',
                        color: form.status === s.val ? s.color : '#555',
                        border: form.status === s.val ? `1px solid ${s.color}` : '1px solid #222',
                      }}>
                      {s.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex gap-2">
              {postSelecionado && (
                <button onClick={deletar}
                  className="px-4 py-2 rounded-lg text-sm"
                  style={{ backgroundColor: '#2a0a0a', color: '#ef4444' }}>
                  Deletar
                </button>
              )}
              <button onClick={() => setModalAberto(false)}
                className="flex-1 py-2 rounded-lg text-sm"
                style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>
                Cancelar
              </button>
              <button onClick={salvar} disabled={salvando}
                className="flex-1 py-2 rounded-lg text-sm font-medium"
                style={{ backgroundColor: '#DCF127', color: '#0a0a0a', opacity: salvando ? 0.7 : 1 }}>
                {salvando ? 'Salvando...' : postSelecionado ? 'Salvar' : 'Adicionar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SocialCalendario;